  <template>
  <div class="box">
    <div class="inpus">
      <div class="searchbox">
        <el-input placeholder="请输入内容" size="mini" v-model="nase">
          <template slot="append"
            ><el-button style="      text-align: center;" @click="selitemis()"   v-preventReClick='3000' round>搜索</el-button></template
          >

        </el-input>
         <div style="color: #D8D8D8;  margin-top: 11px;margin-left: 11px;"> 历史搜索：<span

        style=" cursor: pointer; margin-right:10px;" v-for="item in tesaaas" :key='item.id' @click="setters(item.hotsearch)"   :style="{ color:item.hotsearch===nase ? '#4ccaff':'#999'}" >{{item.hotsearch}}</span></div>
      </div>
    </div>
    <!-- 搜索页面 -->

    <div class="Searchpage">

      <div class="ssk">
         <el-menu
          :default-active="sckecxx"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"

        >
          <el-menu-item
            :style="{ color: sckecxx == '课程' ? ' #4CCAFF' : '#000' }"
            index="课程"
            >课程</el-menu-item
          >
          <el-menu-item
            :style="{ color: sckecxx == '素材' ? ' #4CCAFF' : '#000' }"
            index="素材"
            >素材</el-menu-item
          >
        </el-menu>
            <div class="top">
          <div class="top-Major">
            <p>专业大类:</p>
            <el-radio-group
            @change='selitemis()'
             v-model="radio1" size="mini">
              <el-radio-button label="全部"></el-radio-button>
              <el-radio-button v-for=" item in Majorcategories" :key="item.id"
               :label="item.name"></el-radio-button>

            </el-radio-group>
          </div>
                   <div class="top-Major" v-if="sckecxx === '素材'">
            <p>文件格式:</p>
            <el-radio-group
              @change='selitemis()'
                v-model="radio3" size="mini">
              <el-radio-button label="全部"></el-radio-button>
              <!-- <el-radio-button label="付费"></el-radio-button> -->
              <el-radio-button label="视频"></el-radio-button>
              <el-radio-button label="图片"></el-radio-button>
              <el-radio-button label="动图"></el-radio-button>
            </el-radio-group>
          </div>
          <div class="top-Major">
            <p>是否付费:</p>
            <el-radio-group
             @change='selitemis()'
             v-model="radio2" size="mini">
              <el-radio-button label="全部"></el-radio-button>
              <!-- <el-radio-button label="付费"></el-radio-button> -->
              <el-radio-button label="免费"></el-radio-button>
              <!-- <el-radio-button label="试看"></el-radio-button> -->
            </el-radio-group>
          </div>
          <!-- <div class="top-Major">
            <p>播放方式:</p>
            <el-radio-group v-model="radio3" size="mini">
              <el-radio-button label="全部"></el-radio-button>
              <el-radio-button label="录播"></el-radio-button>
              <el-radio-button label="直播"></el-radio-button>
            </el-radio-group>
          </div> -->
          <div class="top-Major">
            <p>排序方式:</p>
            <el-radio-group

            v-model="radio4" size="mini">
                       <el-radio-button @click.native="payAllotChange($event,9)" label="默认">
              </el-radio-button>
              <el-radio-button @click.native="payAllotChange($event,1)" label="最新">最新
                <img class="ingmssj" src="../../assets/thetriangle.png" alt="">
                <img class="ingmssj" v-if="zx && radio4==='最新'" src="../../assets/thetriangle1.png" alt="">
                <img class="ingmssj1" src="../../assets/sjs.png" alt="">
                <img class="ingmssj1" v-if="zxx&&radio4==='最新'"  src="../../assets/Thetriangle2.png" alt="">
              </el-radio-button>
              <el-radio-button @click.native="payAllotChange($event,2)"  label="收藏"> 收藏
                <img class="ingmssj" src="../../assets/thetriangle.png" alt="">
                <img class="ingmssj"  v-if="sc &&radio4==='收藏'" src="../../assets/thetriangle1.png" alt="">
                <img class="ingmssj1"  src="../../assets/sjs.png" alt="">
                <img class="ingmssj1"   v-if="scc&&radio4==='收藏'"  src="../../assets/Thetriangle2.png" alt="">
              </el-radio-button>

              <el-radio-button label="浏览" @click.native="payAllotChange($event,3)" >
                浏览
                <img class="ingmssj"  src="../../assets/thetriangle.png" alt="">
                <img class="ingmssj"  v-if="ll &&radio4==='浏览'" src="../../assets/thetriangle1.png" alt="">
                <img class="ingmssj1"  src="../../assets/sjs.png" alt="">
                <img class="ingmssj1"   v-if="lll&&radio4==='浏览'"  src="../../assets/Thetriangle2.png" alt="">
              </el-radio-button>
                <el-radio-button label="评分" @click.native="payAllotChange($event,4)" >评分
               <img class="ingmssj"  src="../../assets/thetriangle.png" alt="">
                <img class="ingmssj"  v-if="pfjts &&radio4==='评分'" src="../../assets/thetriangle1.png" alt="">
                <img class="ingmssj1"  src="../../assets/sjs.png" alt="">
                <img class="ingmssj1"   v-if="pfjtx&&radio4==='评分'"  src="../../assets/Thetriangle2.png" alt="">

                </el-radio-button>
              <!-- <el-radio-button label="预约"></el-radio-button> -->
            </el-radio-group>
          </div>
        </div>
      </div>

      <div class="boxs">
        <div class="ssxxz"> <p class="sssl" v-if='this.nase'>
          共找到<span class="spanscs">{{ tepages.total }}</span> 个关于
          <span class="spanscs"> “{{ nase }}” </span> 的课程
        </p></div>
        <ul class="Course"  v-if="sckecxx === '课程'">
          <li class="Live1" v-for="item in templa" :key="item.id">
            <video
              @click="jump(item)"
              class="videshome"
              :src="http + item.sp"
            ></video>
            <div class="thevideo">
              <h4 @click="jump(item)">{{ item.name }}</h4>
              <p class="wb" @click="jump(item)" v-html="item.kcjs"></p>
              <div class="jejq">
                <span class="je">{{ item.jg }}</span>
                <!-- <div>
                  <i
                    style="font-size: 14px; color: #999999; line-height: 20px"
                    class="iconfont gos-yanjing1"
                  ></i>
                  <p class="dzs">浏览量：{{ item.ll }}</p>
                </div> -->
                 <span v-if="radio4==='浏览'||radio4==='默认'" style=" font-size: 12px;   display: flex;  color: #999999;  line-height: 20px;">
                <i  class="iconfont gos-yanjing1" style="  margin-right: 10px;"></i>
                <p class="dzs">浏览量：{{item.ll}}</p>
                </span>
                <span v-if="radio4==='收藏'" style=" font-size: 12px;   display: flex;  color: #999999;  line-height: 20px;">
                <i class="iconfont gos-aixin" style="  margin-right: 10px;"></i>
                <p class="dzs">收藏：{{item.sc}}</p>
                </span>
                <span v-if="radio4==='最新'" style=" font-size: 12px;   display: flex;  color: #999999;  line-height: 20px;">
                <p v-if="sckecxx === '课程'" class="dzs">{{item.itemtime}}</p>
                <!-- <p class="dzs">{{item.statustime}}</p> -->
                </span>
                <span v-if="radio4==='评分'" style=" font-size: 12px;   display: flex;  color: #999999;  line-height: 20px;">
                <el-rate   disabled v-model.number="item.pf"></el-rate>
                </span>
              </div>
              <div class="collection">
                <span @click="eacherpage(item.userid)" class="dzs"
                  ><img :src="http + item.lstx" alt="" />{{ item.lsxm }}</span
                >
                <button class="Buynow" @click="jump(item)">立即查看</button>
              </div>
            </div>
          </li>

        </ul>
<!-- ///////////////////////////////////////// -->
    <ul class="uls" v-if="sckecxx === '素材'">
           <li class="Live1"  v-for="item in templa" :key="item.id">
              <div @click="detailspage(item.id)"
                  class="Figuremove"
                  >
                   <img  v-if="item.wjgs == '图片' ||item.wjgs == '动图'" :src="http+item.scwj" alt="" />
                   <video   v-if="item.wjgs == '视频' " :src="http+item.scwj" ></video>
              </div>
              <div class="Thetitle">
                <div class="Thetitle-top">
                  <p @click="detailspage(item.id)">
                    {{item.scmc}}
                  </p>
                  <span @click="detailspage(item.id)">{{item.wjgs}}</span>
                </div>
                <div class="Thetitle-center">
                 <span class="Thetitle-jg">{{item.sfff}}</span>
                <span v-if="radio4==='浏览'||radio4==='默认'" style=" font-size: 12px;   display: flex;  color: #999999;  line-height: 20px;">
                <i  class="iconfont gos-yanjing1" style="  margin-right: 10px;"></i>
                <p class="dzs">浏览量：{{item.ll}}</p>
                </span>
                <span v-if="radio4==='收藏'" style=" font-size: 12px;   display: flex;  color: #999999;  line-height: 20px;">
                <i class="iconfont gos-aixin" style="  margin-right: 10px;"></i>
                <p class="dzs">收藏：{{item.sc}}</p>
                </span>
                <span v-if="radio4==='最新'" style=" font-size: 12px;   display: flex;  color: #999999;  line-height: 20px;">
                <p class="dzs">{{item.statustime}}</p>
                </span>
                <span v-if="radio4==='评分'" style=" font-size: 12px;   display: flex;  color: #999999;  line-height: 20px;">
                <el-rate   disabled v-model.number="item.pf"></el-rate>
                </span>
                </div>
                <div class="Thetitle-bottom">
                  <div class="Photoname">
                    <img :src="http+item.tx" alt="">
                      <span>
                      {{item.name}}
                      </span>
                  </div>
                   <el-button @click="detailspage(item.id)" >立即查看</el-button>
                </div>
              </div>
            </li>

        </ul>
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :page-size="tepages.rows"
                  prev-text='上一页'
        next-text='下一页'
          layout="prev, pager, next"
          :total="tepages.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { selsort, selmhcxitem, selhotsearch, selscname } from '../../api/patient'
export default {
  data () {
    return {
      pfjts: false,
      pfjtx: false,
      ll: false,
      lll: false,
      sc: false,
      scc: false,
      zx: false,
      zxx: false,
      radio1: '全部',
      radio2: '全部',
      radio3: '全部',
      radio4: '默认',
      Majorcategories: '',
      http: this.$store.state.https,
      sckecxx: '课程',
      nase: '',
      templa: '',
      tesaaas: '',
      tepages: {
        page: 1,
        rows: 12,
        total: 100
      },
      zixinss: false,
      zixinsc: false,
      zixinll: false,
      zixinpf: false,
      saa: 0

    }
  },
  created () {
    // 带过来的值/
    this.nase = this.$route.params.id
    this.selitemis()
    this.selsortis()
    this.selhotsearchis()
  },
  methods: {
    // 最新/
    async  payAllotChange (el, val) {
      if (el.target.tagName === 'STRONG' || el.target.tagName === 'INPUT') return
      if (val === 9) {
        this.zixinss = false
        this.zixinsc = false
        this.zixinll = false
        this.zixinpf = false
      }
      if (val === 1) {
        this.zixinsc = false
        this.zixinll = false
        this.zixinpf = false
        if (this.zixinss) {
          this.zx = false
          this.zxx = true
          this.zzxsjs()
          this.selitemis()
          this.zixinss = false
        } else {
          this.zzxsj()
          this.zxx = false
          this.zx = true
          // this.ynxgss('最新')
          this.selitemis()
          this.zixinss = true
        }
      }
      if (val === 2) {
        this.zixinll = false
        this.zixinss = false
        this.zixinpf = false
        if (this.zixinsc) {
          this.sc = false
          this.scc = true
          this.collectionis()
          this.selitemis()
          this.zixinsc = !this.zixinsc
        } else {
          this.sc = true
          this.scc = false
          this.collectioni()
          this.selitemis()
          this.zixinsc = !this.zixinsc
        }
      }
      if (val === 3) {
        this.zixinsc = false
        this.zixinss = false
        this.zixinpf = false
        if (this.zixinll) {
          this.ll = false
          this.lll = true
          this.llis()
          this.selitemis()
          this.zixinll = !this.zixinll
        } else {
          this.ll = true
          this.lll = false
          this.lliss()
          this.selitemis()
          this.zixinll = !this.zixinll
        }
      }
      if (val === 4) {
        this.zixinsc = false
        this.zixinss = false
        this.zixinll = false
        if (this.zixinpf) {
          this.pfjtx = true
          this.pfjts = false

          this.pfidx()
          this.selitemis()
          this.zixinpf = !this.zixinpf
        } else {
          this.pfjts = true
          this.pfjtx = false
          this.pfids()
          this.selitemis()
          this.zixinpf = !this.zixinpf
        }
      }
    },
    // 素材列表
    // async selmaterialis () {
    //   console.log(this.radio4)
    //   var data = new FormData()
    //   data.append('page', this.tepslds.page)
    //   data.append('rows', this.tepslds.rows)
    //   if (this.radio1 !== '全部') {
    //     data.append('sort', this.radio1)
    //   }
    //   if (this.radio3 !== '全部') {
    //     data.append('wjgs', this.radio3)
    //   }
    //   if (this.radio2 !== '全部') {
    //     data.append('jg', this.radio2)
    //   }
    //   if (this.radio4 !== '默认') {
    //     data.append('px', this.radio4)
    //   }
    //   if (this.nase) {
    //     data.append('name', this.nase)
    //   }
    //   data.append('status', '已通过')
    //   await selscname(data).then(res => {
    //     console.log(res, '列表')
    //     this.teplsta = res.rows
    //     this.tepslds.total = res.total

    //     for (let s = 0; s < this.teplsta.length; s++) {
    //       var a = this.teplsta[s].statustime.split(' ')
    //       this.teplsta[s].statustime = a[0]
    //     }
    //   })
    // },
    // 复制
    setters (item) {
      this.nase = item
      this.selitemis()
    },
    // 素材详情
    detailspage (item) {
      this.$router.push('/materialdetailspage')
      this.$store.commit('sucaixingqi', item)
    },
    // 热门搜索
    selhotsearchis () {
      selhotsearch().then(res => {
        this.tesaaas = res
      })
    },
    // 评分
    pfidx () {
      this.ll = false
      this.lll = false
      this.sc = false
      this.scc = false
      this.zx = false
      this.zxx = false
    },
    pfids () {
      this.ll = false
      this.lll = false
      this.sc = false
      this.scc = false
      this.zx = false
      this.zxx = false
    },
    // 浏览倒
    llis () {
      this.pfjts = false
      this.pfjtx = false

      this.sc = false
      this.scc = false
      this.zx = false
      this.zxx = false
    },
    // 浏览
    lliss () {
      this.pfjts = false
      this.pfjtx = false

      this.sc = false
      this.scc = false
      this.zx = false
      this.zxx = false
    },
    // 收藏倒
    collectionis () {
      this.pfjts = false
      this.pfjtx = false
      this.ll = false
      this.lll = false

      this.zx = false
      this.zxx = false
    },
    // 收藏
    collectioni () {
      this.pfjts = false
      this.pfjtx = false
      this.ll = false
      this.lll = false

      this.zx = false
      this.zxx = false
    },
    // 最新
    async zzxsj () {
      this.pfjts = false
      this.pfjtx = false
      this.ll = false
      this.lll = false
      this.sc = false
      this.scc = false
    },
    async zzxsjs () {
      this.pfjts = false
      this.pfjtx = false
      this.ll = false
      this.lll = false
      this.sc = false
      this.scc = false
    },
    // 上下箭头
    // async ynxgss (item) {
    //   if (this.sckecxx === '课程') {
    //     var data = new FormData()
    //     data.append('page', this.tepages.page)
    //     data.append('rows', this.tepages.rows)
    //     data.append('status', '已发布')
    //     if (this.nase) {
    //       data.append('name', this.nase)
    //     }
    //     if (this.radio1 !== '全部') {
    //       data.append('sort', this.radio1)
    //     }
    //     if (this.radio2 !== '全部') {
    //       data.append('jg', this.radio2)
    //     }
    //     if (this.radio4 !== '默认') {
    //       data.append('px', item)
    //     }
    //     var res = await selmhcxitem(data)

    //     this.templa = res.rows
    //     this.tepages.total = res.total
    //     for (let s = 0; s < this.templa.length; s++) {
    //       var as = this.templa[s].itemtime.split(' ')
    //       this.templa[s].itemtime = as[0]

    //       this.templa[s].pf = Number(this.templa[s].pf)
    //     }
    //   }
    //   if (this.sckecxx === '素材') {
    //     var datas = new FormData()
    //     datas.append('page', this.tepages.page)
    //     datas.append('rows', this.tepages.rows)
    //     if (this.nase) {
    //       datas.append('name', this.nase)
    //     }
    //     if (this.radio3 !== '全部') {
    //       datas.append('wjgs', this.radio3)
    //     }
    //     if (this.radio1 !== '全部') {
    //       datas.append('sort', this.radio1)
    //     }
    //     if (this.radio2 !== '全部') {
    //       datas.append('jg', this.radio2)
    //     }
    //     if (this.radio4 !== '默认') {
    //       datas.append('px', item)
    //     }
    //     datas.append('status', '已通过')
    //     var ress = await selscname(datas)

    //     this.templa = ress.rows

    //     this.tepages.total = ress.total
    //     for (let s = 0; s < this.templa.length; s++) {
    //       var sa = this.templa[s].statustime.split(' ')
    //       this.templa[s].statustime = sa[0]
    //       this.templa[s].pf = Number(this.templa[s].pf)
    //     }
    //   }
    // },
    // 类别搜索
    async  selsortis () {
      var data = new FormData()
      data.append('page', 1)
      data.append('rows', 100)
      await selsort(data).then(res => {
        this.Majorcategories = res.rows
      })
    },
    // 跳转到详情页课程
    jump (item) {
      this.$router.push('/coursedetailspage')
      this.$store.commit('Jumpfordetails', item.id)
    },
    // 跳转老师页面
    eacherpage (item) {
      this.$router.push(`/TeacherDetailsPage/${item}`)
    },
    //   搜索列别
    async  selitemis () {
      if (this.nase !== '') {
        if (this.sckecxx === '课程') {
          var data = new FormData()
          data.append('page', this.tepages.page)
          data.append('rows', this.tepages.rows)
          data.append('name', this.nase)
          data.append('status', '已发布')
          if (this.radio1 !== '全部') {
            data.append('sort', this.radio1)
          }
          if (this.radio2 !== '全部') {
            data.append('jg', this.radio2)
          }
          if (this.sc === true) {
            data.append('px', '收藏倒')
          }
          if (this.scc === true) {
            data.append('px', '收藏')
          }
          if (this.zx === true) {
            data.append('px', '最新')
          }
          if (this.zxx === true) {
            data.append('px', '最新倒')
          }
          if (this.lll === true) {
            data.append('px', '浏览')
          }
          if (this.ll === true) {
            data.append('px', '浏览倒')
          }
          if (this.pfjtx === true) {
            data.append('px', '评分')
          }
          if (this.pfjts === true) {
            data.append('px', '评分倒')
          }

          await selmhcxitem(data).then((res) => {
            this.templa = res.rows
            this.tepages.total = res.total
            for (let s = 0; s < this.templa.length; s++) {
              var a = this.templa[s].itemtime.split(' ')
              this.templa[s].itemtime = a[0]
              this.templa[s].pf = Number(this.templa[s].pf)
            }
          })
        }
        if (this.sckecxx === '素材') {
          var datas = new FormData()
          datas.append('page', this.tepages.page)
          datas.append('rows', this.tepages.rows)
          if (this.radio1 !== '全部') {
            datas.append('sort', this.radio1)
          }
          if (this.radio3 !== '全部') {
            datas.append('wjgs', this.radio3)
          }
          if (this.radio2 !== '全部') {
            datas.append('jg', this.radio2)
          }
          if (this.sc === true) {
            datas.append('px', '收藏倒')
          }
          if (this.scc === true) {
            datas.append('px', '收藏')
          }
          if (this.zx === true) {
            datas.append('px', '最新')
          }
          if (this.zxx === true) {
            datas.append('px', '最新倒')
          }
          if (this.lll === true) {
            datas.append('px', '浏览')
          }
          if (this.ll === true) {
            datas.append('px', '浏览倒')
          }
          if (this.pfjtx === true) {
            datas.append('px', '评分')
          }
          if (this.pfjts === true) {
            datas.append('px', '评分倒')
          }

          if (this.nase) {
            datas.append('name', this.nase)
          }
          datas.append('status', '已通过')
          await selscname(datas).then(res => {
            this.templa = res.rows
            this.tepages.total = res.total
            for (let s = 0; s < this.templa.length; s++) {
              var a = this.templa[s].statustime.split(' ')
              this.templa[s].statustime = a[0]
              this.templa[s].pf = Number(this.templa[s].pf)
            }
          })
        }
      } else {
        this.$message({
          showClose: true,
          message: '请输入搜索内容',
          type: 'warning'
        })
      }
    },
    handleCurrentChange (val) {
      this.tepages.page = val
      this.selitemis()
    },
    handleSelect (val) {
      this.sckecxx = val
      this.selitemis()
    }
  }
}
</script>
<style lang="scss" scoped>
.Searchpage {
  margin-top: 9px;
  width: 100%;
  background: #fff;
  .boxs {
    width: 1090px;
    margin: auto;
    padding: 20px;
    padding-top:18px ;
  }
}
.inpus {
  margin-top: 9px;
  margin-bottom: 5px;
  height: 145px;
  display: flex;
  justify-content: center;
  text-align-last: left;
  // line-height: 145px;
  //    border-bottom: 5px solid #F6F6F6 ;
  background: #fff;
}
.top-Major {
  padding-top: 16px;
  padding-bottom: 15px;
  width: 100%;
  // height: 60px;
  line-height: 30px;
  display: flex;
  text-align: left;
  border-bottom: 1px solid #f3f3f3;
  p {
    height: 30px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    margin-right: 21px;
  }
  .el-radio-group {
    height: 100%;
    .el-radio-button {
      ::v-deep .el-radio-button__inner {
        width: 79px;
        padding: 0px;
        text-align: center;
        height: 30px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        border: 0px solid;
        line-height: 30px;
      }
      ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        width: 79px;
        height: 30px;
        background: #4ccaff;
        border-radius: 14px;
      }
    }
  }
}
.searchbox {
  margin-top: 40px;
  text-align: center;
  width: 697px;
  ::v-deep .el-input__inner {
    border-top-left-radius: 50px;
    border-bottom-left-radius: 50px;
    height: 41px;
    line-height: 41px;

    // border-top-right-radius: 15px;
    // border-bottom-right-radius: 15px;
  }
  ::v-deep .el-input-group__append {
    margin-left: 100px;
    // line-height: 30px;
    border: 0px;
    background: #fff;

    .el-button {

      position: relative;
      left: -55px;
      top: 0px;
      padding: 0px;
      width: 101px;
      padding: 0px 50%;
      height: 43px;
      background: #4ccaff;
      border: 1px solid #ededed;
      border-radius: 50px;
      color: #fff;
font-size: 16px;
    }
  }
}
.Course {
  display: flex;
  width: 100%;
  min-height: 620px;
  //   justify-content: space-between;
  flex-wrap: wrap;
  .Live1 {
    width: 247px;
    height: 299px;
    background: #ffffff;
    border: 1px solid #f6f6f6;
    border-radius: 6px;
    margin-bottom: 20px;
    margin-left: 17px;
    transition: all 0.2s;
    .thevideo {
      display: flex;
      flex-direction: column;
      padding: 10px 20px;
      h4 {
        cursor: pointer;
        white-space: nowrap;
        // width: 126px;
        display: flex;
        height: 14px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
      }
      .wb {  cursor: pointer;
        display: flex;
        text-align: left;
        margin-top: 12px;
        width: 203px;
        height: 38px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        line-height: 19px;
        display: -webkit-box; /**对象作为伸缩盒子模型展示**/
        -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
        -webkit-line-clamp: 2; /**显示的行数**/
        overflow: hidden; /**隐藏超出的内容**/
      }
      .jejq {
        margin-top: 9px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
        .je {
          width: 66px;
          text-align: left;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #ff1616;
        }
        div {
          display: flex;
          img {
            width: 12px;
            height: 12px;
            line-height: 12px;
            margin-right: 8px;
            padding-top: 2px;
          }
          .dzs {

            margin-left: 5px;
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
          }
        }
      }
      .collection {
        // height: 40px;
        border-top: 2px solid #f6f6f6;
        padding-top: 10px;
        display: flex;
        justify-content: space-between;
        .dzs {
          cursor: pointer;
          white-space: nowrap;
          height: 13px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #999999;
          img {
            width: 22px;
            height: 22px;
            border-radius: 50%;
            margin-right: 10px;
          }
        }
        .Buynow {
          cursor: pointer;
          white-space: nowrap;
          // display: flex;
          text-align: center;
          width: 67px;
          height: 23px;
          background: #4ccaff;
          border-radius: 4px;
          border: 1px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
  }
  .Live1:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
  }
}
.videshome {
width: 247px;
height: 140px;
  border-radius: 6px 6px 0px 0px;
  cursor: pointer;
}
.sssl {
  text-align: right;
  margin-right: 35px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  // margin-bottom: 20px;
}
.spanscs {
  color: #4ccaff;
}
  .top {
        .top-Major {
          padding-top: 16px;
          padding-bottom: 15px;
          width: 100%;
          // height: 60px;
          line-height: 30px;
          display: flex;
          text-align: left;
          border-bottom: 1px solid #f3f3f3;
          p {
            height: 30px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
            margin-right: 21px;
          }
          .el-radio-group {
            height: 100%;
            .el-radio-button {
              ::v-deep .el-radio-button__inner {
                width: 79px;
                padding: 0px;
                text-align: center;
                height: 30px;
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #333333;
                border: 0px solid;
                line-height: 30px;
              }
              ::v-deep
                .el-radio-button__orig-radio:checked
                + .el-radio-button__inner {
                width: 79px;
                height: 30px;
                background: #4ccaff;
                border-radius: 14px;
                color: #fff;
              }
            }
          }
        }
           }
.ingmssj{
  position: absolute;
    right: 11PX;
  top: 7px;
    width: 10px;
    height: 8px;
}
.ingmssj1{
    position: absolute;
    right: 11PX;
    top: 15px;
    width: 10px;
    height: 8px;
}

.ssk{
  width: 1090px;
  margin: auto;
}
.ssxxz{
height: 18px;
  margin-bottom: 20px;

}
.el-menu-demo {
    padding-top:20px ;
    height:40px;
    width: 100%;
    line-height: 40px;
    border-bottom: 1px solid #C3EDFF;
    display: flex;
    justify-content: center;
    .el-menu-item {
      margin-left: 50px;
      padding: 0 5px;

      height: 40px;
      line-height: 24px;
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #4CCAFF;
    }
    ::v-deep.is-active {
      border-bottom: 2px solid #4ccaff;
    }
  }
  .uls{
      display: flex;
  width: 100%;
  min-height: 620px;
  //   justify-content: space-between;
  flex-wrap: wrap;
    li {
      width: 247px;
      height: 265px;
      background: #ffffff;
      border: 1px solid #f6f6f6;
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.22);
      border-radius: 6px;
      margin-bottom: 20px;
      margin-right: 20px;
      transition: all 0.2s;
      .Thetitle {
        // display: flex;
        padding: 9px 20px 0px 20px;
        // margin-top: 10px;
        // justify-content: space-between;
        // width: 213px;
        .Thetitle-top {
          display: flex;
          justify-content: space-between;
          p {
            text-align: left;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
            width: 150px;
            height: 18px;
            display: -webkit-box; /**对象作为伸缩盒子模型展示**/
            -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
            -webkit-line-clamp: 1; /**显示的行数**/
            overflow: hidden; /**隐藏超出的内容**/
          }
          span {
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
          }
        }
      }
    }
  }
.Figuremove{
width: 247px;
height: 151px;
// background: #409EFF;
border-radius: 6px 6px 0px 0px;
img{
  width: 100%;
  height: 100%;
}
video{
  width: 100%;
  height: 100%;
}
}
  .Photoname{
display: flex;
    img{
    width: 22px;
    height: 22px;
    border-radius: 50%;
    margin-right: 8px;
    }

  span{
    text-align: left;    font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 22px;
      width: 110px;
display: -webkit-box;
-webkit-box-orient: vertical;
-webkit-line-clamp: 1;
overflow: hidden;
  }
  }
  .Thetitle-bottom{
   display: flex;
  justify-content: space-between;
  margin-top: 11px;
  border-top: 1px solid #F6F6F6;
  padding:  10px 0;
  .Photoname{
display: flex;
    img{
    width: 22px;
    height: 22px;
    border-radius: 50%;
    margin-right: 8px;
    }

  span{
    font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 22px;
      width: 110px;
display: -webkit-box;
-webkit-box-orient: vertical;
-webkit-line-clamp: 1;
overflow: hidden;
  }
  }
.el-button--default{
  padding: 0px;
  text-align: center;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #FFFFFF;
  width: 67px;
  height: 23px;
  background: #4CCAFF;
  border-radius: 4px;
  }
  .el-button:active {
     border-color: #4CCAFF;
  }
}
.Thetitle-center {
  margin-top:12px ;
  display: flex;
  justify-content: space-between;
  .Thetitle-jg {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ff1616;
  }
  .xinx {
    width: 12px;
    height: 11px;
    color: #999999;
    margin-right: 5px;
  }
}
.el-pagination{
 ::v-deep span{
  padding: 0 10px;
}
}

</style>
